import { Menu, MenuButton, IconButton, MenuList, MenuItem, Box, useDisclosure, } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import KebabMenuIcon from '../../icons/KebabIcon/KebabIcon';
import { RenderIf } from '../RenderIf/RenderIf';
import { useManyDisclosureProxy } from '../../../hooks/state/useManyDisclosureProxy';
import { DeleteContactModalWrapper } from './DeleteContactModalWrapper';
import { localise } from '../../../services/lang/lang';
import { CLOSED } from '../../../constants/statuses';
import { buildClickAndKeyDownEvents } from '../../../services/utils';
import EditContactModal from '../Contacts/Modal/EditContactModal';
import { UnsavedChangesProvider } from '../UnsavedChanges/UnsavedChangesProvider';
const ContactsActionMenu = ({ canEditContacts, contact, inspection, onContactMutated, onContactDeleted, onEditContactClicked, }) => {
    const tokens = useTokens();
    const { buildOnOpen, isOpen, buildOnClose, onClose } = useManyDisclosureProxy({
        deleteContactModal: useDisclosure(),
        editContactModal: useDisclosure(),
    });
    const isEditable = inspection.status.id !== CLOSED && canEditContacts;
    const actions = [
        {
            label: isEditable ? localise('VIEW_EDIT') : localise('VIEW'),
            testId: 'contacts_action_menu__edit',
            condition: true,
            onClick: onEditContactClicked
                ? () => onEditContactClicked(contact)
                : buildOnOpen('editContactModal'),
        },
        {
            label: localise('DELETE'),
            condition: isEditable,
            testId: 'contacts_action_menu__delete',
            onClick: buildOnOpen('deleteContactModal'),
        },
    ];
    return (React.createElement(Box, null,
        React.createElement(Menu, null,
            React.createElement(MenuButton, { onClick: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation(), as: IconButton, "data-testid": "contacts_action_menu__kebab_button", colorScheme: tokens.Layer01, icon: React.createElement(KebabMenuIcon, null), tabIndex: 0, "aria-label": localise('CONTACT_ACTIONS') }),
            React.createElement(MenuList, null, actions.map((action) => (React.createElement(RenderIf, { key: action.label, condition: action.condition },
                React.createElement(MenuItem, { "data-testid": action.testId, ...buildClickAndKeyDownEvents(() => action.onClick?.()), tabIndex: 0 }, action.label)))))),
        React.createElement(RenderIf, { condition: isOpen('deleteContactModal') },
            React.createElement(DeleteContactModalWrapper, { contact: contact, onClose: buildOnClose('deleteContactModal'), onSuccess: () => {
                    onClose('deleteContactModal');
                    onContactMutated?.(localise('CONTACT_DELETED'));
                    onContactDeleted?.();
                } })),
        React.createElement(RenderIf, { condition: isOpen('editContactModal') },
            React.createElement(UnsavedChangesProvider, null,
                React.createElement(EditContactModal, { isOpen: true, onClose: buildOnClose('editContactModal'), contact: contact, canEdit: isEditable, onEditContact: () => {
                        onContactMutated?.();
                        onClose('editContactModal');
                    } })))));
};
export default ContactsActionMenu;
